import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Container,
    Grid,
    Card,
    CardContent,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    CircularProgress,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function CoreValue() {
    const [corevalue, setCorevalue] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get("/files/corporate/corevalue.txt")
            .then((res) => {
                setCorevalue(res.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            {/* --- Heading --- */}
            <Typography
                align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mt: 7,
                    mb: { xs: 2, sm: 3, md: 4 },
                    fontSize: {
                        xs: "1.8rem",  // mobile
                        sm: "2.2rem",  // tablet
                        md: "2.8rem",  // laptop
                        lg: "3rem",    // desktop
                    },
                }}
            >
                Core Value
            </Typography>

            {/* --- Subheading --- */}
            <Typography
                align="center"
                sx={{
                    mb: { xs: 3, sm: 4 },
                    color: "#030366",
                    fontWeight: 500,
                    fontSize: {
                        xs: "1.1rem",
                        sm: "1.25rem",
                        md: "1.4rem",
                    },
                }}
            >
                VENSYX Data Solutions Core Values
            </Typography>

            {/* --- Loader --- */}
            {loading ? (
                <Box display="flex" justifyContent="center" mt={5}>
                    <CircularProgress />
                </Box>
            ) : (
                <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="flex-start"
                    sx={{
                        flexDirection: {
                            xs: "column", // mobile & tablet: stack
                            md: "row",    // laptop & desktop: same as before
                        },
                    }}
                >
                    {/* --- Content Card --- */}
                    <Grid
                        item
                        xs={12}
                        md={8}
                        sx={{
                            width: {
                                xs: "100%",
                                sm: "100%",
                                md: "80%",
                            },
                        }}
                    >
                        <Card
                            sx={{
                                backgroundColor: "#f8f9fa",
                                borderRadius: 3,
                                boxShadow: 3,
                                px: { xs: 0, sm: 2, md: 3 },
                                py: { xs: 1, sm: 2, md: 3 },
                            }}
                        >
                            <CardContent>
                                {corevalue &&
                                    corevalue.map((item, index) => (
                                        <List key={index} sx={{ py: 0 }}>
                                            {item.VENSYX.map((details, idx) => (
                                                <ListItem
                                                    key={idx}
                                                    sx={{
                                                        pl: 0,
                                                        py: { xs: 0.1, sm: 0.7 },
                                                    }}
                                                >
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: "35px",
                                                            color: "#4caf50",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <CheckCircleIcon />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={details}
                                                        primaryTypographyProps={{
                                                            sx: {
                                                                fontFamily: "Raleway, sans-serif",
                                                                textAlign: "justify",
                                                                fontSize: {
                                                                    xs: "0.95rem",
                                                                    sm: "1rem",
                                                                    md: "1.05rem",
                                                                },
                                                                lineHeight: 1.7,
                                                            },
                                                        }}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    ))}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default CoreValue;








// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//     Box,
//     Typography,
//     Container,
//     Grid,
//     Card,
//     CardContent,
//     List,
//     ListItem,
//     ListItemIcon,
//     ListItemText,
//     CircularProgress,
// } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// function CoreValue() {
//     const [corevalue, setCorevalue] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         axios
//             .get("/files/corporate/corevalue.txt")
//             .then((res) => {
//                 setCorevalue(res.data);
//                 setLoading(false);
//             })
//             .catch(() => setLoading(false));
//     }, []);

//     return (
//         <Container maxWidth="lg" sx={{ py: 2 }}>
//             <Typography
//                 variant="h3"
//                 align="center"
//                 gutterBottom
//                 sx={{ fontWeight: "bold", color: "#030366", mt: 7 }}
//             >
//                 Core Value
//             </Typography>

//             <Typography
//                 variant="h5"
//                 align="center"
//                 sx={{ mb: 4, color: "#030366" }}
//             >
//                 VENSYX Data Solutions Core Values
//             </Typography>

//             {loading ? (
//                 <Box display="flex" justifyContent="center" mt={5}>
//                     <CircularProgress />
//                 </Box>
//             ) : (
//                 <Grid
//                     container
//                     spacing={2}
//                     alignItems="center"
//                     sx={{
//                         display: "flex",
//                         flexDirection: "row",
//                         justifyContent: "center",
//                         alignItems: "flex-start",
//                     }}
//                 >
//                     <Grid item xs={12} md={8}>
//                         <Card
//                             sx={{
//                                 backgroundColor: "#f8f9fa",
//                                 borderRadius: 3,
//                                 boxShadow: 3,
//                             }}
//                         >
//                             <CardContent>
//                                 {corevalue &&
//                                     corevalue.map((item, index) => (
//                                         <List key={index}>
//                                             {item.VENSYX.map((details, idx) => (
//                                                 <ListItem key={idx} sx={{ pl: 0 }}>
//                                                     <ListItemIcon>
//                                                         <CheckCircleIcon sx={{ color: "#4caf50" }} />
//                                                     </ListItemIcon>
//                                                     <ListItemText
//                                                         primary={details}
//                                                         primaryTypographyProps={{
//                                                             sx: {
//                                                                 fontFamily: "Raleway, sans-serif",
//                                                                 textAlign: "justify",
//                                                             },
//                                                         }}
//                                                     />
//                                                 </ListItem>
//                                             ))}
//                                         </List>
//                                     ))}
//                             </CardContent>
//                         </Card>
//                     </Grid>
//                 </Grid>
//             )}
//         </Container>
//     );
// }

// export default CoreValue;
